import { ActionReducerMap } from '@ngrx/store';
import { APPLICATION_STATE_KEY, applicationReducer, IApplicationState } from './application.reducer';
import { DEFAULT_ROUTER_FEATURENAME, routerReducer } from '@ngrx/router-store';
import { RouterReducerState } from '@ngrx/router-store/src/reducer';
import { AUTH_STATE_KEY, authReducer, IAuthState } from './auth.reducer';
import { CLAIMS_STATE_KEY, claimsReducer, IClaimsState } from './claims.reducer';
import { ACCOUNTS_STATE_KEY, accountsReducer, IAccountsState } from './accounts.reducer';
import { ISitesState, SITES_STATE_KEY, sitesReducer } from './sites.reducer';
import {
  IUserPreferencesState,
  USER_PREFERENCES_REDUCER,
  USER_PREFERENCES_STATE_KEY,
} from './user-preferences.reducer';
import {
  INotApplicableCriteriaState,
  NOT_APPLICABLE_CRITERIA_REDUCER,
  NOT_APPLICABLE_CRITERIA_STATE_KEY,
} from './not-applicable-criteria.reducer';
import { APPLICATION_FILTERS_REDUCER, FILTERS_STATE_KEY, IApplicationFiltersState } from './filters.reducer';
import { CI_RULE_ACTIONS_REDUCER, CI_RULE_ACTIONS_STATE_KEY, ICIRuleActionsState } from './ci-rule-actions.reducer';
import { ACCOUNT_SITES_STATE_KEY, accountSitesReducer, IAccountSitesState } from './account-sites.reducer';
import { IScorecardsState, SCORECARDS_STATE_KEY, SCORECARDS_REDUCER } from './scorecards.reducer';

export interface IRootState {
  [AUTH_STATE_KEY]: IAuthState;
  [APPLICATION_STATE_KEY]: IApplicationState;
  [DEFAULT_ROUTER_FEATURENAME]: RouterReducerState;
  [CLAIMS_STATE_KEY]: IClaimsState;
  [ACCOUNTS_STATE_KEY]: IAccountsState;
  [SITES_STATE_KEY]: ISitesState;
  [SCORECARDS_STATE_KEY]: IScorecardsState;
  [USER_PREFERENCES_STATE_KEY]: IUserPreferencesState;
  [NOT_APPLICABLE_CRITERIA_STATE_KEY]: INotApplicableCriteriaState;
  [FILTERS_STATE_KEY]: IApplicationFiltersState;
  [CI_RULE_ACTIONS_STATE_KEY]: ICIRuleActionsState;
  [ACCOUNT_SITES_STATE_KEY]: IAccountSitesState;
}

const reducers: ActionReducerMap<IRootState> = {
  [AUTH_STATE_KEY]: authReducer,
  [APPLICATION_STATE_KEY]: applicationReducer,
  [DEFAULT_ROUTER_FEATURENAME]: routerReducer,
  [CLAIMS_STATE_KEY]: claimsReducer,
  [ACCOUNTS_STATE_KEY]: accountsReducer,
  [SITES_STATE_KEY]: sitesReducer,
  [SCORECARDS_STATE_KEY]: SCORECARDS_REDUCER.reducer,
  [USER_PREFERENCES_STATE_KEY]: USER_PREFERENCES_REDUCER.reducer,
  [NOT_APPLICABLE_CRITERIA_STATE_KEY]: NOT_APPLICABLE_CRITERIA_REDUCER.reducer,
  [FILTERS_STATE_KEY]: APPLICATION_FILTERS_REDUCER.reducer,
  [CI_RULE_ACTIONS_STATE_KEY]: CI_RULE_ACTIONS_REDUCER.reducer,
  [ACCOUNT_SITES_STATE_KEY]: accountSitesReducer,
};

export const reducersFactory = (): ActionReducerMap<IRootState> => reducers;
